import { useRemoveAiQueriesMutation } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AsyncLoadStatus } from '../common/types';
import { ButtonLoadMore } from '../components/actions/ButtonLoadMore';
import AiAgentMessage from './AiAgentMessage';
import {
  aiAgentQueries,
  aiAgentQueriesLoadStatus,
  aiAgentQueriesState,
} from './store/aiAgent.state';
import { LoadAiQueriesParamsBase } from './store/aiAgent.types';

export type AiAgentMessageLogProps = {
  loadAiQueries: (params: LoadAiQueriesParamsBase) => void;
};

const AiAgentMessageLog: React.FC<AiAgentMessageLogProps> = props => {
  const { t } = useTranslation('app');
  const [messages, setMessages] = useRecoilState(aiAgentQueries);
  const [logState, setLogState] = useRecoilState(aiAgentQueriesState);
  const logStatus = useRecoilValue(aiAgentQueriesLoadStatus);
  const [removeAiQuery] = useRemoveAiQueriesMutation();

  const loadedCount = _.size(messages);
  const totalCount = logState?.totalCount;
  const isLoading =
    logStatus === AsyncLoadStatus.Loading || logStatus === AsyncLoadStatus.None;

  function loadNext() {
    props.loadAiQueries({
      skip: loadedCount,
      isAppend: true,
    });
  }

  async function removeMessage(messageId: string) {
    setMessages(_.filter(messages, m => m.id !== messageId));
    setLogState({ totalCount: totalCount - 1 });
    try {
      const { data, errors } = await removeAiQuery({
        variables: {
          ids: [messageId],
        },
      });

      if (!_.isNil(errors)) {
        console.error(errors);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div
      key={`${logState?.totalCount}-${loadedCount}`}
      data-component="AiAgentMessageLog"
      className="relative flex flex-1 flex-col space-y-4"
    >
      <ButtonLoadMore
        itemsCount={loadedCount}
        totalCount={totalCount}
        onNext={loadNext}
        isLoading={isLoading}
        totalLabel={t`Total:`}
      />
      {_.map(messages, m => (
        <AiAgentMessage
          key={m.id}
          messageId={m.id}
          onRemoveClick={removeMessage}
        />
      ))}
    </div>
  );
};

export default AiAgentMessageLog;
